import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomErrorHandlerService } from '../custom-error-handler.service';
import { PreferenceWhitelist } from '../../../models/preference-whitelist/preference-whitelist.model';
import { PreferenceWhitelistSerializer } from '../../../models/preference-whitelist/preference-whitelist-serializer.class';

@Injectable()
export class PreferenceWhitelistService extends BaseApiService<PreferenceWhitelist> {
    constructor(httpClient: HttpClient) {
        super(
            httpClient, 
            null, 
            "preferencewhitelists",
            new PreferenceWhitelistSerializer(), 
            new CustomErrorHandlerService()
        );
    }
    
    /*validate(value: string): Observable<any> {
        return this.httpClient.get(`${this.url}/validate/${encodeURIComponent(value)}`);
    }*/
}
